import React from 'react';
import styled from 'styled-components';
import checkmark from '@catalogo/ui-americanas-desktop-svg/checkmark.svg';
import { ICheckProps } from './types';

export const FormCheckbox: React.FC<ICheckProps> = ({ onClick, children }) => (
  <Label>
    <WrapperCheck>
      <Input onClick={onClick} type="checkbox" />
      <Check />
    </WrapperCheck>
    {!!children && <Span>{children}</Span>}
  </Label>
);

const WrapperCheck = styled.span`
  width: 27px;
  display: inline-block;
  position: relative;
  cursor: pointer;
  margin: 8px;
  height: 25px;
`;

const Span = styled.span``;

const Label = styled.label`
  display: flex;
`;

const Input = styled.input`
  width: 20px;
  height: 19px;
  appearance: none;
  border-radius: 2px;
  background-color: #fff;
  border: 1px solid ${({ theme }) => theme.grey.darker};

  &:checked {
    border: none;
    background-color: ${({ theme }) => theme.primaryColor};
  }
`;

const Check = styled(checkmark)`
  fill: white;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  path {
    stroke-width: 10px;
  }
`;

export default FormCheckbox;
